export default __webpack_public_path__ + "static/media/box.291b0581.svg";